import { device } from "@src/theme";
import styled from "styled-components";

export const PlaylistOverviewHeader = styled.div`
  display: flex;
  height: 130px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const PlaylistOverviewHeaderLeft = styled.div`
  display: flex;
  flex: 1;
  height: 130px;
`;
export const PlaylistOverviewHeaderRight = styled.div`
  display: flex;
  flex: 1;
  height: 130px;
  justify-content: space-between;
  flex-direction: column;
  justify-content: flex-end;
`;
export const PlaylistOverviewHeaderCenter = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 130px;
  @media ${device.mobile} {
    display: none;
  }
  @media ${device.tablet} {
    display: none;
  }
  @media ${device.laptop} {
    display: flex;
  }
  @media ${device.desktop} {
    display: flex;
  }
`;

export const TotalLabel = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }): string => theme.colors.yellow};

  @media ${device.mobile} {
    font-size: 1rem;
  }

  @media ${device.tablet} {
    font-size: 18px;
  }

  @media ${device.laptop} {
    font-size: 20px;
  }
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
`;

export const BottomButtons = styled.div`
  display: flex;
  gap: ${(props): string => props.theme.margins.medium};
`;
export const BottomButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AddActionButton = styled.button<{ $active?: boolean }>`
  background-color: ${({ $active, theme }): string =>
    $active ? theme.colors.yellow : theme.colors.darkGray};
  border: 1px solid
    ${({ $active, theme }): string =>
      $active ? theme.colors.darkGray : theme.colors.yellow};
  color: ${({ $active, theme }): string =>
    $active ? theme.colors.darkGray : theme.colors.yellow};
  font-size: 1rem;
  font-weight: bold;
  width: 100px;
  height: 40px;
  border-radius: 25px;
  cursor: pointer;
`;

export const SelectContainer = styled.div`
  display: flex;
  gap: 32px;
  @media ${device.mobile} {
    gap: 16px;
  }
`;

export const SelectWrapper = styled.div`
  flex: 1;
  border-radius: 5px;
  outline-color: ${({ theme }): string => theme.colors.yellow};
  border-color: ${({ theme }): string => theme.colors.yellow};
  border-width: 1px;
  border-style: solid;
  padding: 10px;
`;

export const StyledSelect = styled.select`
  width: 100%;
  border: none;
  user-select: none;
  background-color: ${({ theme }): string => theme.colors.darkGray};
  color: ${({ theme }): string => theme.colors.yellow};
  outline: none;
`;

export const SearchContainer = styled.div`
  display: flex;
  gap: 32px;
  min-height: 60px;
  align-items: flex-end;
  @media ${device.tablet} {
    gap: 16px;
  }
`;
export const MobileTotalCountContainer = styled.div`
  display: none;
  gap: 32px;
  @media ${device.mobile} {
    display: flex;
  }
`;

export const SearchInputWrapper = styled.div`
  flex: 2;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const TotalLabelWrapper = styled.div`
  padding: 5px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${device.mobile} {
    display: none;
  }
`;
export const MobileTotalLabelWrapper = styled.div`
  padding: 5px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
